import React from "react";
import { useNavigate } from "react-router-dom";

const Category = ({ dropdownCategories = [], loading }) => {
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId) => {
    navigate(`/product/${categoryId}`);
  };

  const Allcategory = () => {
    navigate("/Allcategory");
  };

  return (
    <div className="content-innercat">



      <section className="overflow-hidden section-head">
        <div className="container">

          <div className="headingFIX">
          
              <div
                className="section-head style-1 m-b30  wow fadeInUp width50"
                data-wow-delay="0.2s"
              >
             
                <div className="left-content ">
                  <h2 className="title">All  categories</h2>
    
                </div>
              </div>
             
        
           
              <div className="VIewall width51" onClick={Allcategory}>
              <span className="viewAllIN">View All</span>
              </div>
          
          </div>



          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
           ) : dropdownCategories.length === 0 ? (
            <div className="text-center py-5">
              <div className="nodata">No Popular categories available</div>

            </div>
          ) : (
            <div className="row gx-xl-4 g-3">
              {dropdownCategories.map((cat) => (
                <div
                  key={cat._id}   // ✅ KEY MUST BE HERE
                  className="col-lg-4 col-xl-3 col-md-6 col-sm-6 relative mobilecard"
                  onClick={(e) => {
                    e.preventDefault();
                    handleCategoryClick(cat._id);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="SP_card">
                    <div className="SP_image_wrapper2 CateGAmin">
                      <img
                        className="SP_frame_image"
                        src={`${process.env.REACT_APP_API_URL}/uploads/${cat.image}`}
                        alt={cat.name}
                        width="40"
                        height="40"
                      />
                      <a className="share-btn"  onClick={(e) => e.preventDefault()} />
                    </div>

                    <div
                      className="SP_customize_button2"
                   
                      onClick={(e) => {
                        e.preventDefault();
                        handleCategoryClick(cat._id);
                      }}
                    >
                     
                      <span className="d-md-block">{cat.name}</span>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          )}
        </div>
      </section>














    </div>
  );
};

export default Category;